import { dateOfBirthRegex, phoneRegex } from '@/constants/regex';
import { TIdentificationRequestPrefill } from '@/models/chat.model';
import { UserDataFormFields } from './types';

export const enum IdentificationVariant {
  DEFAULT = 'default',
  BOTH_MISSING = 'both_missing',
  PHONE_MISSING = 'phone_missing',
  BIRTHDATE_MISSING = 'birthdate_missing',
}

export type TFieldErrors = Partial<Record<UserDataFormFields, boolean>>;

type TIdentificationVariantConfig = {
  fieldErrors: TFieldErrors;
  subtitle: string;
};

const DEFAULT_SUBTITLE = 'Будь ласка, поділіться даними для ідентифікації.';
const NO_ERRORS: TFieldErrors = {};

export const IDENTIFICATION_VARIANTS: Record<IdentificationVariant, TIdentificationVariantConfig> = {
  [IdentificationVariant.DEFAULT]: {
    fieldErrors: NO_ERRORS,
    subtitle: DEFAULT_SUBTITLE,
  },
  [IdentificationVariant.BOTH_MISSING]: {
    fieldErrors: { [UserDataFormFields.PHONE]: true, [UserDataFormFields.BIRTHDATE]: true },
    subtitle: DEFAULT_SUBTITLE,
  },
  [IdentificationVariant.PHONE_MISSING]: {
    fieldErrors: { [UserDataFormFields.PHONE]: true },
    subtitle: 'Вкажіть номер телефону, щоб отримати відповідь',
  },
  [IdentificationVariant.BIRTHDATE_MISSING]: {
    fieldErrors: { [UserDataFormFields.BIRTHDATE]: true },
    subtitle: 'Вкажіть дату народження, щоб отримати відповідь',
  },
};

export const getIdentificationVariantKey = (userInfo?: TIdentificationRequestPrefill | null): IdentificationVariant => {
  if (!userInfo) return IdentificationVariant.DEFAULT;

  const hasPhone = !!userInfo.phone;
  const hasBirthdate = !!userInfo.birthdate;

  if (hasPhone && !hasBirthdate) return IdentificationVariant.BIRTHDATE_MISSING;
  if (hasBirthdate && !hasPhone) return IdentificationVariant.PHONE_MISSING;
  if (!hasPhone && !hasBirthdate) return IdentificationVariant.BOTH_MISSING;
  return IdentificationVariant.DEFAULT;
};

export const FIELD_PATTERNS: Record<UserDataFormFields, RegExp> = {
  [UserDataFormFields.PHONE]: phoneRegex,
  [UserDataFormFields.BIRTHDATE]: dateOfBirthRegex,
};

export const isFieldValueValid = (field: UserDataFormFields, value?: string): boolean =>
  !!value && FIELD_PATTERNS[field]?.test(value);
